import {normalizeSearchCharacters} from "./isExerciseMatch";

function createSearchIndex(value) {
    const normalizedCharacters = [];
    const normalizedToOriginalStart = [];
    const normalizedToOriginalEnd = [];
    let originalIndex = 0;

    for (const character of Array.from(value || "")) {
        const originalStart = originalIndex;
        originalIndex += character.length;
        const normalizedCharacter = normalizeSearchCharacters(character);

        if (/^\s+$/.test(normalizedCharacter)) {
            continue;
        }

        for (const normalizedPart of Array.from(normalizedCharacter)) {
            normalizedCharacters.push(normalizedPart);
            normalizedToOriginalStart.push(originalStart);
            normalizedToOriginalEnd.push(originalIndex);
        }
    }

    return {
        normalized: normalizedCharacters.join(""),
        normalizedToOriginalStart: normalizedToOriginalStart,
        normalizedToOriginalEnd: normalizedToOriginalEnd,
    };
}

export function getHighlightRanges(text, query) {
    const value = text || "";
    const search = (query || "").trim();
    if (!value || !search) {
        return [];
    }

    const valueIndex = createSearchIndex(value);
    const searchIndex = createSearchIndex(search);
    const normalizedSearch = searchIndex.normalized;
    if (!normalizedSearch) {
        return [];
    }

    const ranges = [];
    let normalizedIndex = valueIndex.normalized.indexOf(normalizedSearch);
    while (normalizedIndex !== -1) {
        const normalizedEndIndex = normalizedIndex + normalizedSearch.length - 1;
        ranges.push({
            start: valueIndex.normalizedToOriginalStart[normalizedIndex],
            end: valueIndex.normalizedToOriginalEnd[normalizedEndIndex],
        });
        normalizedIndex = valueIndex.normalized.indexOf(normalizedSearch, normalizedIndex + normalizedSearch.length);
    }

    return ranges;
}

export function getHighlightedTextSegments(text, query) {
    const value = text || "";
    const ranges = getHighlightRanges(value, query);
    if (ranges.length === 0) {
        return [{text: value, highlighted: false}];
    }

    const segments = [];
    let start = 0;
    for (const range of ranges) {
        if (range.start > start) {
            segments.push({text: value.substring(start, range.start), highlighted: false});
        }
        segments.push({text: value.substring(range.start, range.end), highlighted: true});
        start = range.end;
    }
    if (start < value.length) {
        segments.push({text: value.substring(start), highlighted: false});
    }

    return segments;
}
